module.exports = __webpack_public_path__ + "static/media/pic7.8f1cad79.jpg";